//---------------------------------------------------
//  Nom du fichier : RoutingMachine.js 
//
//  Description: Component qui le calcul d'itinéraire vers un endroit sur la carte gérer par leaflet
//               Permet d'avoir les étapes selon la langue choisi par l'utilisateur
//
//  Auteur: Alek Del Balso
//---------------------------------------------------


import L from "leaflet";
import { createControlComponent } from "@react-leaflet/core";
import "leaflet-routing-machine";
import { createColorIcon } from './Icon';
  
//https://www.liedman.net/leaflet-routing-machine/

const createRoutineMachineLayer = ({ onRouteCalculated, position, destination, setDestination, lang}) => {
  const instance = L.Routing.control({
    waypoints: [
      L.latLng(position.lat, position.lng),
      L.latLng(destination[0], destination[1])
    ],
    lineOptions: {
      styles: [{ color: "#6FA1EC", weight: 4 }]
    },

    //MAP BOX pour production use, 100 000 free request par mois
    router: L.Routing.mapbox('pk.eyJ1IjoiZGVsYmFsc28iLCJhIjoiY203N3djOTViMG9jOTJucHkwODVzNm13bCJ9.kZJ2_T63U_YJDui4owEdxA', {
        language: lang.split('-')[0]
    }),
    addWaypoints: false,
    routeWhileDragging: false,
    draggableWaypoints: true,
    fitSelectedRoutes: true,
    showAlternatives: false,
    language:lang,
    createMarker: function (i, waypoint) {
      // Only create a marker for the first waypoint (start position)
      if (i === 0) { // For the start position (index 0)
        return L.marker(waypoint.latLng, {
          draggable: true,
          icon: createColorIcon(require('./Images/waypoint_icon.png'))
        });
      }
      // For the destination waypoint (index 1), don't create a marker
      return null; // Don't return any marker for the destination
    }
  });

  instance.on("routesfound", function (e) {
    const instructions = e.routes[0].instructions.map((instr, index) => ({
      text: instr.text,
      position: e.routes[0].coordinates[instr.index] // Get corresponding coordinate
    }));
    onRouteCalculated(instructions);
  });
  instance.on("routingerror", function (e) {
    console.error("Routing error:", e);
    alert("No valid route found! The destination may be unreachable.");
    setDestination([])
  })

  setTimeout(() => {
    const container = instance.getContainer();
    if (container) {
      container.style.display = "none"; // Hide the default UI
    }
  }, 1);

  return instance;
};

const RoutingMachine = createControlComponent(createRoutineMachineLayer);

export default RoutingMachine;
